export let BalciaLinks = {
    landing: () => `/balcia`,
    selectTime: () => `/balcia/select-time`,
    bookAppointment: (appointmentId, bookingId) => `/balcia/appointments/${appointmentId}/bookings/${bookingId}/book`
}
